import axios from 'axios';
import config from './../config';
import {
    addingSecurityGroup,
    addSecurityGroupFail,
    addSecurityGroupSuccess,
    deletingSecurityGroup,
    fetchAppsFailed,
    fetchAppsSuccess,
    fetchingApps,
    fetchingPermissions, fetchingSecurityGroup,
    fetchingSecurityGroups,
    fetchPermissionsFail,
    fetchPermissionsSuccess, fetchSecurityGroupFailed,
    fetchSecurityGroupsFailed,
    fetchSecurityGroupsSuccess, fetchSecurityGroupSuccess,
    securityGroupDeleteFail,
    securityGroupDeleteSuccess,
    patchSecurityGroupFailed, patchSecurityGroupSuccess, patchingSecurityGroup, updatingPermissions,
    updatePermissionsSuccess, updatePermissionsFailed, updatingUsers, updateUsersSuccess, updateUsersFailed,
    updateAppsSuccess, updateAppsFailed, updatingApps
} from '../actions/SecurityGroupActions';
import { getApiError, getHeaders, getHttpClient } from './CommonFunctions';

let permissionsUrl = config.get('PERMISSIONS_API_URL');
const httpClient = getHttpClient(permissionsUrl);

function getVersionFromResponse(response, defaultVersion = 1) {
    let version = response.headers && response.headers.etag ? response.headers.etag : null;
    if (version === null)
        version = defaultVersion + 1;
    else {
        version = version.substring(version.lastIndexOf('v') + 1);
    }
    return version;
}

function createSecurityGroup(securityGroup) {
    let headers = getHeaders();
    return dispatch => {
        dispatch(addingSecurityGroup());
        let data = JSON.stringify(securityGroup);
        httpClient.post('/roles', data, { headers })
            .then(response => {
                dispatch(addSecurityGroupSuccess(response.data));
            }).catch(err => {
            let error = getApiError(err);
            dispatch(addSecurityGroupFail(error))
        });
    }
}

function deleteSecurityGroup(groupId) {
    let url = `/roles/${groupId}`;
    let headers = getHeaders();
    return dispatch => {
        dispatch(deletingSecurityGroup());
        httpClient.delete(url, { headers })
            .then(() => {
                dispatch(securityGroupDeleteSuccess(groupId));
            })
            .catch((err) => {
                let error = getApiError(err);
                dispatch(securityGroupDeleteFail(error));
            });
    }
}

function patchSecurityGroup(patchRequest) {
    let url = `/roles/${patchRequest.id}`;
    let headers = getHeaders();
    let ifMatch = `${patchRequest.id}v${patchRequest.version}`;
    headers = { ...headers, 'If-Match': ifMatch };
    let data = JSON.stringify(patchRequest);
    return dispatch => {
        dispatch(patchingSecurityGroup());
        httpClient.patch(url, data, { headers })
            .then((response) => {
                let version = getVersionFromResponse(response, patchRequest.version);
                dispatch(patchSecurityGroupSuccess(version));
            })
            .catch((err) => {
                let error = getApiError(err);
                dispatch(patchSecurityGroupFailed(error));
            });
    };
}

function putSecurityGroupPermissions(permissionPutRequest) {
    let { id, version, permissions } = permissionPutRequest;
    let url = `/roles/${id}/permissions`;
    let headers = getHeaders();
    let ifMatch = `${id}v${version}`;
    headers = { ...headers, 'If-Match': ifMatch };
    let data = JSON.stringify(permissions);
    return dispatch => {
        dispatch(updatingPermissions());
        httpClient.put(url, data, { headers })
            .then(response => {
                let version = getVersionFromResponse(response);
                dispatch(updatePermissionsSuccess(version));
            })
            .catch(err => {
                let error = getApiError(err);
                dispatch(updatePermissionsFailed(error));
            });
    };
}

function putSecurityGroupUsers(putUsersRequest) {
    let { id, users } = putUsersRequest;
    let url = `/roles/${id}/users`;
    let headers = getHeaders();
    let data = JSON.stringify(users);
    return dispatch => {
        dispatch(updatingUsers());
        httpClient.put(url, data, { headers })
            .then(() => {
                dispatch(updateUsersSuccess({ id, users: JSON.parse(data) }));
            })
            .catch(err => {
                let error = getApiError(err);
                dispatch(updateUsersFailed(error));
            });
    };
}

function putSecurityGroupApps(putAppsRequest) {
    let { appIds, id, version } = putAppsRequest;
    let url = `/roles/${id}/apps`;
    let headers = getHeaders();
    let ifMatch = `${id}v${version}`;
    headers = { ...headers, 'If-Match': ifMatch };
    let data = JSON.stringify(appIds);
    return dispatch => {
        dispatch(updatingApps());
        httpClient.put(url, data, { headers })
            .then((response) => {
                let version = getVersionFromResponse(response);
                dispatch(updateAppsSuccess(version));
            })
            .catch((err) => {
                let error = getApiError(err);
                dispatch(updateAppsFailed(error));
            });
    }
}

function fetchPermissions() {
    let url = '/permissions';
    let headers = getHeaders();
    return dispatch => {
        dispatch(fetchingPermissions());
        httpClient.get(url, { headers })
            .then(response => {
                dispatch(fetchPermissionsSuccess(response.data));
            }).catch(err => {
            let error = getApiError(err);
            dispatch(fetchPermissionsFail(error));
        });
    };
}

function fetchApps() {
    let url = '/apps';
    let headers = getHeaders();
    return dispatch => {
        dispatch(fetchingApps());
        httpClient.get(url, { headers })
            .then(response => {
                dispatch(fetchAppsSuccess(response.data));
            })
            .catch(err => {
                let error = getApiError(err);
                dispatch(fetchAppsFailed(error))
            });
    }
}

function fetchSecurityGroups() {
    let headers = getHeaders();
    let url = '/roles';
    return dispatch => {
        dispatch(fetchingSecurityGroups());
        httpClient.get(url, { headers })
            .then((response) => {
                dispatch(fetchSecurityGroupsSuccess(response.data));
            })
            .catch((err) => {
                let error = getApiError(err);
                dispatch(fetchSecurityGroupsFailed(error));
            });
    }
}

function fetchSecurityGroup(id) {
    let headers = getHeaders();
    let url = `/roles/${id}`;
    return dispatch => {
        dispatch(fetchingSecurityGroup());
        httpClient.get(url, { headers })
            .then((response) => {
                dispatch(fetchSecurityGroupSuccess(response.data));
            })
            .catch((err) => {
                let error = getApiError(err);
                dispatch(fetchSecurityGroupFailed(error));
            });
    };
}

export {
    createSecurityGroup,
    fetchPermissions,
    fetchApps,
    deleteSecurityGroup,
    fetchSecurityGroups,
    fetchSecurityGroup,
    patchSecurityGroup,
    putSecurityGroupPermissions,
    putSecurityGroupUsers,
    putSecurityGroupApps
}
